import React, { useContext } from 'react';
import styles from '../../css/functional.module.scss';
import SearchContext from '../data/FunnelbackContext';
import ListView from './ListView';

function Favourites() {
    const { isFetching, localStorageState, favourites } = useContext(SearchContext);

    if (isFetching) {
        return (
            <>
                <div className="sr-only">Loading...</div>
                {[...Array(5)].map((item, index) => (
                    <div
                        className="funnelback-instant-search-generic-result--loading"
                        // eslint-disable-next-line react/no-array-index-key
                        key={`result-${index}`}
                    />
                ))}
            </>
        );
    }

    if (localStorageState?.favourites.length === 0) {
        return (
            <div className={`${styles.favourites} funnelback-instant-search-favourites`}>
                <div className={`${styles.favouritesTop} funnelback-instant-search-favourites--top`}>
                    <img src={favourites?.bannerImage || ''} alt={favourites?.bannerAlt || ''} />
                    <div className={`${styles.favouritesTopInner} funnelback-instant-search-favourites--top--inner`}>
                        <h1> Favourite programs</h1>
                        <div>
                            <button type="button">
                                Find more programs
                                <svg>
                                    <title>Find more programs</title>
                                    <use href="#compare" />
                                </svg>
                            </button>
                            <button type="button">
                                Send to yourself
                                <svg>
                                    <title>Send to yourself</title>
                                    <use href="#send" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`${styles.favouritesItems} funnelback-instant-search-favourites--items`}>
                    <h4>No saved favourites.</h4>
                </div>
            </div>
        );
    }

    return (
        <div className={`${styles.favourites} funnelback-instant-search-favourites`}>
            <div className={`${styles.favouritesTop} funnelback-instant-search-favourites--top`}>
                <img src={favourites?.bannerImage || ''} alt={favourites?.bannerAlt || ''} />
                <div className={`${styles.favouritesTopInner} funnelback-instant-search-favourites--top--inner`}>
                    <h1> Favourite programs</h1>
                    <div>
                        <button type="button">
                            Find more programs
                            <svg>
                                <title>Find more programs</title>
                                <use href="#compare" />
                            </svg>
                        </button>
                        <button type="button">
                            Send to yourself
                            <svg>
                                <title>Send to yourself</title>
                                <use href="#send" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div className={`${styles.favouritesItems} funnelback-instant-search-favourites--items`}>
                <div className={`${styles.listView} funnelback-instant-search-list-view`}>
                    <ul>
                        {localStorageState?.favourites.map((item) => (
                            <li key={item.indexUrl}>
                                <ListView {...item} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Favourites;
